export function getPreviousApprovedQuoteQuerySuffix(
  salesOrderId: string,
  currentApprovalSignatureDate?: string | null
): string {
  return (
    `&$filter=_dsy_salesorder_value eq '${salesOrderId}' ` +
    `and statecode eq 2 ` +
    `and dsy_approvalsignaturedatetime ne null ` +
    (currentApprovalSignatureDate
      ? `and dsy_approvalsignaturedatetime lt '${currentApprovalSignatureDate}' `
      : '') +
    `&$orderby=dsy_approvalsignaturedatetime desc` +
    `&$top=1`
  )
}
